import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";
import round from "lodash/round";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type CreateProductLine = ClientInferResponseBody<typeof contract.productLines.createInline>;

export type CreateProductLineDto = ClientInferRequest<
  typeof contract.productLines.createInline
>["body"];

export const createProductLine = async ({
  id,
  payload,
}: {
  id: string;
  payload: CreateProductLineDto;
}): Promise<CreateProductLine> => {
  if (!id) {
    throw new Error("L'id de la demande est requis");
  }

  const response = await api.productLines.createInline.mutation({
    params: {
      id,
    },
    body: {
      ...payload,
      price: round(payload.price),
      fixedPrice: payload.fixedPrice ? round(payload.fixedPrice) : undefined,
      product: {
        ...payload.product,
        price: round(payload.product.price),
        fixedPrice: payload.product.fixedPrice ? round(payload.product.fixedPrice) : undefined,
      },
    },
  });

  if (response.status === 201) {
    return response.body;
  }

  throw new ApiError("Erreur lors de la création de l'achat", response.status, response.body);
};
